var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "fulfilling-bouncing-circle-spinner",
      style: _vm.spinnerStyle
    },
    [
      _c("div", { staticClass: "circle", style: _vm.circleStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "orbit", style: _vm.orbitStyle })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }